export default __webpack_public_path__ + "d86f844ff7dca8d7424688a7ef0ac990.webp";